import type { SVGProps } from 'react'
const SvgSyDanger = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M11.25 16.27c0-.414.336-.756.75-.756s.75.33.75.745v.01a.75.75 0 0 1-1.5 0" opacity={0.4} />
		<g strokeLinejoin="round">
			<path d="M12.781 3.115a2.82 2.82 0 0 0-3.258 1.346L2.252 17.188a1 1 0 0 0-.043.09 2.84 2.84 0 0 0 1.555 3.685h.002c.293.118.604.186.916.203l.035-.031.078.033h14.482l.04-.002a2.84 2.84 0 0 0 2.68-2.97v-.005a2.8 2.8 0 0 0-.206-.918 1 1 0 0 0-.043-.086L14.477 4.46l-.002-.002a2.82 2.82 0 0 0-1.694-1.342m-.412 1.432c.325.093.615.313.795.639l.004.01 7.238 12.67a1.318 1.318 0 0 1-1.164 1.803H4.795l-.014.005-.015-.004a1.4 1.4 0 0 1-.436-.096l-.004-.002a1.317 1.317 0 0 1-.728-1.717l7.234-12.66.006-.01c.12-.218.3-.398.517-.517l.002-.002c.326-.18.687-.213 1.012-.12" />
			<path
				d="M11.99 9.547a.75.75 0 0 0-.75.75v3.1a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-3.1a.75.75 0 0 0-.75-.75"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyDanger
